import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { OrderEntriesPickup, Warehouse } from '@tracking/const';
@Component({
  selector: 'sd-tracking-pickup-scheme',
  templateUrl: './tracking-pickup-scheme.component.html',
  styleUrls: ['./tracking-pickup-scheme.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TrackingPickupSchemeComponent implements OnInit {
  @Input() scheme: string;
  @Input() orderEntries: OrderEntriesPickup[];

  warehouses: Warehouse[] = [];

  ngOnInit(): void {
    this.warehouses = this.mapOrderEntriesToWarehouses(this.orderEntries);
  }

  mapOrderEntriesToWarehouses(orderEntries: OrderEntriesPickup[]): Warehouse[] {
    // Группируем товары по складам, потом сортируем по названию склада от 1 и дальше
    return orderEntries.reduce<Warehouse[]>((warehouses, orderEntry) => {
      const index = warehouses.findIndex((warehouse) => warehouse.name === orderEntry.pickup.warehouseName);
      if (orderEntry.pickup.warehouseName) {
        if (index === -1) {
          warehouses.push({
            name: orderEntry.pickup.warehouseName,
            orderEntries: [orderEntry],
            visible: false,
          });
        } else {
          warehouses[index].orderEntries.push(orderEntry);
        }
      }

      return warehouses;
    }, []);
  }

  toggleWarehouse(warehouse: Warehouse): void {
    warehouse.visible = !warehouse.visible;
  }
}
